export default __webpack_public_path__ + "static/media/p2023-33.bd92c741.jpeg";